




































import { Component, Vue, Inject } from 'vue-property-decorator';
import { ActivityController, ConsultController } from '@/services/request.service';
import { fixIOSScroll, getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';

@Component
export default class SignIn extends Vue {
  @Inject() public readonly reloadPage!: any;
  public form: any;
  public activityInfo: any = {};
  public config = config;
  public status: string = 'fill'; // fill || submit
  public loading: boolean = false;
  public fixIOSScroll = fixIOSScroll;
  public activityId: number = -1;

  public get school() {
    return getSchoolInfo().shortName;
  }

  public created(): void {
    this.activityId = parseInt(this.$route.params.activityId, 10);
    this.getActivityInfo();
  }

  public beforeCreate(): void {
    this.form = this.$form.createForm(this);
  }

  public get rules() {
    return {
      mobile: [{ required: true, message: this.$t('warningTip.enquiryMobileInvaild'), pattern: /^[0-9]{11}$/ }],
    };
  }

  public getActivityInfo() {
    ActivityController.getActivityDetail(this.activityId).then(res => {
      this.activityInfo = res.data;
    });
  }

  public handleSubmit(e: any) {
    e.preventDefault();
    this.form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err && !this.loading) {
        this.loading = true;
        ConsultController.signIn(this.activityId, values.mobile)
          .then(res => {
            const { signInFlag, activityChannelId } = res.data;
            if (signInFlag) {
              this.status = 'submit';
            } else {
              this.$router.push({
                name: 'enquiry',
                params: { activityChannelId: activityChannelId.toString() },
                query: { signInDirectFlag: 'true', mobile: values.mobile },
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
  }
}
